export default (str) => str.toLowerCase().replace(/^[a-z]/,  (x) =>  x.toUpperCase());
